
import React, { Component } from 'react';
import { Layout, Breadcrumb } from 'antd';
import { Link, browserHistory } from 'react-router';
// import routes from '../routes';

const { Header } = Layout;

export default class MainBreadcrumb extends Component {

    constructor(props) {
        super(props);
        this.state = {
            breadcrumbDataList: [],
            loading: false
        }
    }

    refresh(breadcrumbList) {
        this.state.breadcrumbDataList = breadcrumbList || [];
        this.setState({ loading: false });
    }

    pushItem(data) {

        if (!data) {
            return;
        }

        let existIndex = -1;
        let maxIndex = this.state.breadcrumbDataList.length - 1;
        this.state.breadcrumbDataList.forEach((element, index) => {
            if (element.path == data.path) {
                existIndex = index;
            }
        });

        if (existIndex >= 0) {
            this.state.breadcrumbDataList.splice(existIndex, maxIndex - existIndex);
        } else {

            this.state.breadcrumbDataList.push(data);
        }

        this.setState({ loading: false });
    }

    onClick(path) {

        let existIndex = -1;
        let maxIndex = this.state.breadcrumbDataList.length - 1;
        this.state.breadcrumbDataList.forEach((element, index) => {
            if ((element.path || element.describe) == path) {
                existIndex = index;
            }
        });

        if (existIndex >= 0) {
            this.state.breadcrumbDataList.splice(existIndex + 1, maxIndex - existIndex);
            this.setState({ loading: false });
            browserHistory.go(existIndex - maxIndex);
        }
    }

    goBack(n) {
        // this.state.breadcrumbDataList.pop();
        // this.setState();

        if (n) {
            tool.sgiLogger.info(n);
            if (n < 0) {
                for (let index = 0; index > n; index--) {
                    this.state.breadcrumbDataList.pop();
                }
            }
        } else {
            this.state.breadcrumbDataList.pop();
        }
        this.setState();
    }

    render() {
        let BreadcrumbItemList = [];
        if (this.state.breadcrumbDataList && this.state.breadcrumbDataList.length > 0) {
            this.state.breadcrumbDataList.forEach(element => {
                if (element.path || element.describe) {
                    BreadcrumbItemList.push(<Breadcrumb.Item><Link onClick={this.onClick.bind(this, element.path || element.describe)}>{element.name}</Link></Breadcrumb.Item>)
                    // BreadcrumbItemList.push(<Breadcrumb.Item><Link onClick={this.onClick.bind(this)} to={element.path + '?uid=' + element.uid}>{element.title}</Link></Breadcrumb.Item>)
                } else {
                    BreadcrumbItemList.push(<Breadcrumb.Item>{element.name}</Breadcrumb.Item>);
                }
            });
        }

        return (
            <Breadcrumb>
                <Breadcrumb.Item><Link to={'/main'} onClick={() => { this.setState({ breadcrumbDataList: [] }); }} > 首页</Link></Breadcrumb.Item>
                {BreadcrumbItemList}
            </Breadcrumb>
        )
    }
}


// WEBPACK FOOTER //
// ./apps/pages/main/layout/MainBreadcrumb.js